import React, { useState } from "react";
import KuikaCollapsePanel from "../../../../ui-kit/kuika-collapse-panel/kuika-collapse-panel";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

interface IItem {
  key: string;
  label: React.ReactNode;
  children: React.ReactNode;
}

const ITEMS: IItem[] = [
  {
    key: "general",
    label: "General",
    children: <div style={{ padding: 16, color: "var(--lab-ink-muted)" }}>Project name, locale and default screen.</div>
  },
  {
    key: "data",
    label: (
      <span style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
        <KuikaSvg name="database" width={14} height={14} />
        Datasources
      </span>
    ),
    children: <div style={{ padding: 16, color: "var(--lab-ink-muted)" }}>SQL, REST and custom datasources.</div>
  },
  {
    key: "auth",
    label: "Authentication",
    children: <div style={{ padding: 16, color: "var(--lab-ink-muted)" }}>JWT, Microsoft Entra, custom SSO.</div>
  }
];

type CollapseKey = string | number;

interface IStatefulProps {
  initial?: CollapseKey[];
  expandIconPosition?: "left" | "right";
  animated?: boolean;
}

const Stateful: React.FC<IStatefulProps> = ({ initial, ...rest }) => {
  const [keys, setKeys] = useState<CollapseKey[]>(initial ?? ["general"]);
  return (
    <KuikaCollapsePanel
      items={ITEMS.map((item: IItem) => ({ key: item.key, label: item.label, children: item.children }))}
      activeKey={keys}
      onChange={(k: CollapseKey[]) => setKeys(k)}
      {...rest}
    />
  );
};

export const CollapsePanelStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Collapse Panel"
      componentName="KuikaCollapsePanel"
      sourcePath="ui-kit/kuika-collapse-panel"
      description="Accordion list backed by rc-collapse. Panels open and close with a grid-row height motion by default (--dur-base; at once under reduced motion); the chevron turns with them."
    >
      <SpecRow label="Default" caption="animated, chevron left" align="stretch">
        <div style={{ width: 480 }}>
          <Stateful initial={["general"]} />
        </div>
      </SpecRow>
      <SpecRow label="Chevron right" caption="expandIconPosition='right'" align="stretch">
        <div style={{ width: 480 }}>
          <Stateful initial={["data"]} expandIconPosition="right" />
        </div>
      </SpecRow>
      <SpecRow label="Without motion" caption="animated={false} — opens and closes at once" align="stretch">
        <div style={{ width: 480 }}>
          <Stateful initial={["general", "auth"]} animated={false} />
        </div>
      </SpecRow>
    </ShowcaseFrame>
  );
};
